<template>
  <!-- 对话框 -->
  <el-drawer title="服务人员资金流水" :visible.sync="show" :with-header="false" size="600px" destroy-on-close>


    <div style="width: 95%;margin: 20px;">

      <h2>调整签约日期</h2>

      <div class="text">
        <span>司机名称: <span style="margin-left: 5px;">{{ driver_name }}</span> </span>

        <span>电话: <span class="orange" style="margin-left: 5px;">{{ driver_phone }}</span> </span>

        <span>签约到期时间：{{oldEndTime}} </span>

      </div>



      <el-button style="margin: 20px 0; color: #000; cursor: unset; " type="text">修改签约时间：</el-button>
      <!-- <el-input style="width: 0;"></el-input> -->

      <el-date-picker v-model="endTime" type="datetime" placeholder="选择日期" @change="changeData" format="yyyy-MM-dd HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>

      <el-button @click="addData" style="margin-left: 10px;" type="primary">确定修改</el-button>

    </div>


  </el-drawer>
</template>

<script>
  var _this;

  import bus from '../../common/bus.js';
  export default {
    props: {
      'isShow': Boolean,
      'data': '',
      'driverName': '',
      'driverPhone': '',
      'driver_or_legwork':''
    },

    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.driver_name = _this.driverName;

        _this.driver_phone = _this.driverPhone;

        _this.driver_code = _this.data;

  _this.getDriverPoints();


      },

    },
    data() {
      return {

        show: false,

        search_time: '',
        driver_name: '',
        driver_phone: '',
        driver_code: '',

        endTime: '', //最新签约到期时间
        oldEndTime: '', //之前签约到期时间
        valueData: '',

      };
    },
    created() {

      _this = this;

    },

    methods: {

      getDriverPoints(){
        var httpURL = ''

        if(this.driver_or_legwork == '0'){
          //  代驾司机
          httpURL = '/driver/getDriverPointsDetails'
        }else if(this.driver_or_legwork == '1'){
          //  跑腿骑手
          httpURL = '/sign/editSigningLegworkSubmit'
        }

        _this.$post(
            '/driver/getDriverPointsDetails', {
              driver_code: _this.driver_code
            }
          )
          .then(res => {

            if(this.driver_or_legwork == '0'){
              //  代驾司机

              // 将获取到的数据赋值
              if (res.data.signing_end_time.YmdHis != '未设置') {
                _this.endTime = res.data.signing_end_time.YmdHis
              }
              if (res.data.signing_end_time.YmdHis != '未设置') {
                _this.oldEndTime = res.data.signing_end_time.YmdHis

              }


            }else if(this.driver_or_legwork == '1'){
              //  跑腿骑手

              // 将获取到的数据赋值
              if (res.data.legwork_signing_end_time.YmdHis != '未设置') {
                _this.endTime = res.data.legwork_signing_end_time.YmdHis
              }
              if (res.data.legwork_signing_end_time.YmdHis != '未设置') {
                _this.oldEndTime = res.data.legwork_signing_end_time.YmdHis

              }


            }

          }).catch((err) => {

          })
      },

      changeData(val) {

        _this.valueData = val


      },


      addData() {

        var httpURL=""

        if(this.driver_or_legwork == '0'){
          //  代驾司机
          httpURL = '/driver/editSigningDriverSubmit'
        }else if(this.driver_or_legwork == '1'){
          //  跑腿骑手
          httpURL = '/sign/editSigningLegworkSubmit'
        }
        _this.$post(
                httpURL, {
              driver_code: _this.driver_code,
              signing_end_time: _this.valueData
            }
          )
          .then(res => {

            // 将获取到的数据赋值

            // console.log(res)
            _this.$message.success({
              message: res.msg,
              duration: 1500
            });


          _this.getDriverPoints();



          }).catch((err) => {

            _this.$message.success({
              message: res.msg,
              duration: 1500
            });

          })
      },



    }
  };
</script>

<style scoped>
  h2 {
    font-family: Microsoft YaHei;
    font-weight: 600;
    line-height: 21px;
    color: #222;
    font-size: 18px;
    margin-bottom: 20px;
  }

  .text {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .text>span {
    margin-right: 10px;

  }

  .money-box {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
  }

  .money {
    margin-left: 5px;
  }

  .orange {
    color: rgb(255, 149, 11);
    font-weight: 600;
  }
</style>
